var _defs, _g, _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _rect5, _path7, _g2, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _g3, _path38, _g4, _path39, _path40, _g5, _g6, _path41, _path42, _path43, _path44, _path45, _path46, _g7, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _g8, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashDownloadImg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 768.673,
    height: 293.472,
    viewBox: "0 0 768.673 293.472",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -227.384,
    y1: 32.995,
    x2: -228.27,
    y2: 32.995,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b57f7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#95545a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -146.519,
    y1: 0.5,
    x2: -145.519,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 220.942,
    y1: 0.5,
    x2: 219.485,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 302.311,
    y1: 0.5,
    x2: 301.311,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.328,
    y1: -0.857,
    x2: 0.668,
    y2: -0.857,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -207.893,
    y1: -5.378,
    x2: -206.581,
    y2: -5.378,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -195.582,
    y1: -2.316,
    x2: -194.582,
    y2: -2.316,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35404",
    "data-name": "Group 35404",
    transform: "translate(-1004.327 -3898.396)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35405",
    "data-name": "Group 35405",
    transform: "translate(0 -91)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16597",
    "data-name": "Group 16597",
    transform: "translate(-2951.992 3782.272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16379",
    "data-name": "Group 16379",
    transform: "translate(4260.993 207.124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11164",
    "data-name": "Path 11164",
    d: "M4307.572,396.679c31.109,76.4,167.516,96.588,258.42,83.188,32.313-4.763,142.282-20.973,175.084-99.7,16.8-40.329,14.128-98.989-27.712-137.441-27.164-24.965-68.083-38.663-106.707-35.023-59.73,5.628-62.38,47.855-130.1,65.547-68.9,18-102.636-16.13-140.132,8.659C4302.158,304.562,4292.006,358.45,4307.572,396.679Z",
    transform: "translate(-4358.242 -207.124)",
    fill: "#f0efff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16396",
    "data-name": "Group 16396",
    transform: "translate(4342.901 245.214)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16391",
    "data-name": "Group 16391",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16390",
    "data-name": "Group 16390"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11277",
    "data-name": "Path 11277",
    d: "M5046.481,443.242V614.653a11.516,11.516,0,0,1-11.26,11.756H4794.2a11.516,11.516,0,0,1-11.26-11.756V443.245a11.516,11.516,0,0,1,11.26-11.756h241.027A11.513,11.513,0,0,1,5046.481,443.242Z",
    transform: "translate(-4782.938 -431.489)",
    fill: "#f5f8ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16392",
    "data-name": "Group 16392",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17893",
    "data-name": "Rectangle 17893",
    width: 263.544,
    height: 15.005,
    fill: "#cecefd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16393",
    "data-name": "Group 16393",
    transform: "translate(16 5.589)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_848",
    "data-name": "Ellipse 848",
    cx: 1.914,
    cy: 1.914,
    r: 1.914,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16394",
    "data-name": "Group 16394",
    transform: "translate(23.381 5.589)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_849",
    "data-name": "Ellipse 849",
    cx: 1.914,
    cy: 1.914,
    r: 1.914,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16395",
    "data-name": "Group 16395",
    transform: "translate(30.763 5.589)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_850",
    "data-name": "Ellipse 850",
    cx: 1.914,
    cy: 1.914,
    r: 1.914,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16415",
    "data-name": "Group 16415",
    transform: "translate(4362.729 328.907)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16397",
    "data-name": "Group 16397",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11278",
    "data-name": "Path 11278",
    d: "M5050.344,929.663v85.575a5.187,5.187,0,0,1-5.187,5.187H4904.918a5.187,5.187,0,0,1-5.187-5.187V929.663a5.187,5.187,0,0,1,5.187-5.186h140.238A5.187,5.187,0,0,1,5050.344,929.663Z",
    transform: "translate(-4899.732 -924.477)",
    fill: "#eeedfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16400",
    "data-name": "Group 16400",
    transform: "translate(15.481 16.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16398",
    "data-name": "Group 16398"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17894",
    "data-name": "Rectangle 17894",
    width: 31.896,
    height: 5.29,
    rx: 2.645,
    fill: "rgba(171,171,240,0.38)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16399",
    "data-name": "Group 16399",
    transform: "translate(0 10.191)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17895",
    "data-name": "Rectangle 17895",
    width: 61.926,
    height: 2.645,
    rx: 1.323,
    fill: "rgba(171,171,240,0.38)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16404",
    "data-name": "Group 16404",
    transform: "translate(120.038 14.378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16401",
    "data-name": "Group 16401"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11279",
    "data-name": "Path 11279",
    d: "M5621.9,1016.72a7.546,7.546,0,1,1-7.545-7.548A7.513,7.513,0,0,1,5621.9,1016.72Z",
    transform: "translate(-5606.807 -1009.172)",
    fill: "#ababf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16402",
    "data-name": "Group 16402",
    transform: "translate(4.229 1.674)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_851",
    "data-name": "Ellipse 851",
    cx: 2.346,
    cy: 2.346,
    r: 2.346,
    transform: "translate(0 3.317) rotate(-45)",
    fill: "#f5f8ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16403",
    "data-name": "Group 16403",
    transform: "translate(1.931 8.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11280",
    "data-name": "Path 11280",
    d: "M5629.411,1065.431a7.543,7.543,0,0,1-11.23,0,6.14,6.14,0,0,1,11.23,0Z",
    transform: "translate(-5618.18 -1061.775)",
    fill: "#f5f8ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16405",
    "data-name": "Group 16405",
    transform: "translate(45.558 52.794)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11281",
    "data-name": "Path 11281",
    d: "M5176.069,1235.455l-3.75,2.262a14.486,14.486,0,0,1-4.233,17.208l2.276,3.746a18.83,18.83,0,0,0,5.707-23.217Z",
    transform: "translate(-5168.086 -1235.455)",
    fill: "#ababf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16406",
    "data-name": "Group 16406",
    transform: "translate(29.195 42.073)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11282",
    "data-name": "Path 11282",
    d: "M5079.045,1172.305a18.743,18.743,0,0,0-7.341,1.488l2.087,3.852a14.492,14.492,0,0,1,16.628,4.535l3.754-2.262A18.842,18.842,0,0,0,5079.045,1172.305Z",
    transform: "translate(-5071.704 -1172.305)",
    fill: "#f5f8ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16407",
    "data-name": "Group 16407",
    transform: "translate(17.687 45.297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11283",
    "data-name": "Path 11283",
    d: "M5022.762,1221.421a14.49,14.49,0,0,1-8.441-26.27l-2.087-3.855h0a18.849,18.849,0,0,0,18.729,32.605l-2.276-3.743A14.455,14.455,0,0,1,5022.762,1221.421Z",
    transform: "translate(-5003.913 -1191.295)",
    fill: "#ababf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16414",
    "data-name": "Group 16414",
    transform: "translate(77.419 46.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16408",
    "data-name": "Group 16408",
    transform: "translate(0 0.467)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17896",
    "data-name": "Rectangle 17896",
    width: 4.59,
    height: 2.878,
    rx: 1.439,
    fill: "rgba(171,171,240,0.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16409",
    "data-name": "Group 16409",
    transform: "translate(10.969)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17897",
    "data-name": "Rectangle 17897",
    width: 30.496,
    height: 3.812,
    rx: 1.906,
    fill: "rgba(171,171,240,0.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16410",
    "data-name": "Group 16410",
    transform: "translate(0 12.525)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17898",
    "data-name": "Rectangle 17898",
    width: 4.59,
    height: 2.878,
    rx: 1.439,
    fill: "rgba(171,171,240,0.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16411",
    "data-name": "Group 16411",
    transform: "translate(10.969 12.058)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17899",
    "data-name": "Rectangle 17899",
    width: 39.832,
    height: 3.812,
    rx: 1.906,
    fill: "rgba(171,171,240,0.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16412",
    "data-name": "Group 16412",
    transform: "translate(0 24.584)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17900",
    "data-name": "Rectangle 17900",
    width: 4.59,
    height: 2.878,
    rx: 1.439,
    fill: "rgba(171,171,240,0.29)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16413",
    "data-name": "Group 16413",
    transform: "translate(10.969 24.117)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17901",
    "data-name": "Rectangle 17901",
    width: 18.827,
    height: 3.812,
    rx: 1.906,
    fill: "rgba(171,171,240,0.29)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16516",
    "data-name": "Group 16516",
    transform: "translate(4360.682 270.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16512",
    "data-name": "Group 16512",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18163",
    "data-name": "Rectangle 18163",
    width: 67.078,
    height: 49.593,
    rx: 4,
    fill: "#eeedfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16513",
    "data-name": "Group 16513",
    transform: "translate(5.759 6.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12424",
    "data-name": "Path 12424",
    d: "M4942.844,648.282c-2.65,0-4.183-3.789-5.956-8.173-1.63-4.031-3.479-8.6-5.913-8.754-1.271-.08-3.97,1.081-7.756,9.777a.849.849,0,1,1-1.556-.678c3.248-7.459,6.336-10.992,9.42-10.793,3.5.222,5.472,5.1,7.379,9.812,1.348,3.334,2.876,7.112,4.386,7.112h.012c1.932-.026,3.845-5.957,5.382-10.723,2.187-6.782,4.253-13.187,8.037-13.358,2.745-.123,4.708,3.078,6.606,6.175,1.133,1.848,2.684,4.379,3.588,4.181,1.131-.248,1.778-4.214,2.25-7.11.8-4.9,1.707-10.462,5.234-11.434a4.461,4.461,0,0,1,2.611.118.849.849,0,0,1-.531,1.612,2.8,2.8,0,0,0-1.63-.094c-2.478.682-3.328,5.888-4.009,10.07-.729,4.47-1.3,8-3.562,8.5a2.291,2.291,0,0,1-.489.054c-1.841,0-3.273-2.335-4.91-5.006-1.564-2.552-3.335-5.45-5.083-5.367-2.606.118-4.764,6.808-6.5,12.183-2.052,6.362-3.824,11.857-6.975,11.9Z",
    transform: "translate(-4921.591 -614.173)",
    fill: "rgba(100,87,232,0.17)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16514",
    "data-name": "Group 16514",
    transform: "translate(33.818 8.619)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_854",
    "data-name": "Ellipse 854",
    cx: 5.811,
    cy: 5.811,
    r: 5.811,
    transform: "translate(0 11.471) rotate(-80.783)",
    fill: "#6457e8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16515",
    "data-name": "Group 16515",
    transform: "translate(37.471 12.273)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_855",
    "data-name": "Ellipse 855",
    cx: 3.013,
    cy: 3.013,
    r: 3.013,
    fill: "#6457e8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16591",
    "data-name": "Group 16591",
    transform: "translate(4439.767 236.28)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16585",
    "data-name": "Group 16585",
    transform: "translate(0 33.546)",
    opacity: 0.355
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13057",
    "data-name": "Path 13057",
    d: "M5398,626.605h-38.823a5.667,5.667,0,0,1-5.66-5.66V582.122a5.667,5.667,0,0,1,5.66-5.66H5398a5.667,5.667,0,0,1,5.66,5.66v38.822A5.667,5.667,0,0,1,5398,626.605Zm-38.823-49.634a5.157,5.157,0,0,0-5.151,5.151v38.822a5.157,5.157,0,0,0,5.151,5.151H5398a5.156,5.156,0,0,0,5.151-5.151V582.122a5.156,5.156,0,0,0-5.151-5.151Z",
    transform: "translate(-5353.514 -576.462)",
    fill: "#ababf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16590",
    "data-name": "Group 16590",
    transform: "translate(11.761)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16586",
    "data-name": "Group 16586"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13058",
    "data-name": "Path 13058",
    d: "M5484.6,385.6v48.35a6.732,6.732,0,0,1-6.732,6.732h-48.35a6.731,6.731,0,0,1-6.732-6.732V385.6a6.732,6.732,0,0,1,6.732-6.732h48.35A6.734,6.734,0,0,1,5484.6,385.6Z",
    transform: "translate(-5422.791 -378.863)",
    fill: "#bebef7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16589",
    "data-name": "Group 16589",
    transform: "translate(13.693 13.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16587",
    "data-name": "Group 16587"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13059",
    "data-name": "Path 13059",
    d: "M5537.877,476.741a17.213,17.213,0,1,1-17.214-17.212v6.714a10.5,10.5,0,1,0,10.5,10.5Z",
    transform: "translate(-5503.451 -459.529)",
    fill: "#f3f2ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16588",
    "data-name": "Group 16588",
    transform: "translate(17.212)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13060",
    "data-name": "Path 13060",
    d: "M5622.051,476.741h-6.713a10.5,10.5,0,0,0-10.5-10.5v-6.714A17.214,17.214,0,0,1,5622.051,476.741Z",
    transform: "translate(-5604.837 -459.529)",
    fill: "#ababf0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16596",
    "data-name": "Group 16596",
    transform: "translate(4523.391 318.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16592",
    "data-name": "Group 16592",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13061",
    "data-name": "Path 13061",
    d: "M5886.937,867.819v28.41a3.779,3.779,0,0,1-3.778,3.78h-33.288a3.78,3.78,0,0,1-3.779-3.78v-28.41a3.78,3.78,0,0,1,3.779-3.779h33.288A3.778,3.778,0,0,1,5886.937,867.819Z",
    transform: "translate(-5846.092 -864.04)",
    fill: "#eeedfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16595",
    "data-name": "Group 16595",
    transform: "translate(7.704 8.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16593",
    "data-name": "Group 16593",
    transform: "translate(0 4.802)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13062",
    "data-name": "Path 13062",
    d: "M5891.471,956.349h25.438l-5.537-8.523-4.327,5.8-6.878-11.551Z",
    transform: "translate(-5891.471 -942.073)",
    fill: "#ababf0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16594",
    "data-name": "Group 16594",
    transform: "translate(15.444)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_863",
    "data-name": "Ellipse 863",
    cx: 3.115,
    cy: 3.115,
    r: 3.115,
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_864",
    "data-name": "Ellipse 864",
    cx: 16.278,
    cy: 16.278,
    rx: 16.278,
    ry: 16.278,
    transform: "translate(1701.916 4003.311)",
    fill: "#ffe293"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16602",
    "data-name": "Group 16602",
    transform: "translate(1707.05 4015.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M117.59,75.937a12.692,12.692,0,0,0-6.04-10.067c-6.04-3.775-9.312,2.013-12.584,3.9S94.184,59.83,87.641,54.293s-12-1.007-14.052,6.04-6.837,9.061-12.625,5.537S51.4,74.427,51.652,75.937Z",
    transform: "translate(-51.64 -51.821)",
    fill: "#eeedfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M59.375,63.881c-1.581-4.762-5.279-9.35-7.735-12.036,1.883-.15,3.982.566,6.209,2.45,6.544,5.537,8.054,17.365,11.325,15.478s6.543-7.676,12.584-3.9A12.692,12.692,0,0,1,87.8,75.939H59.946A23.516,23.516,0,0,0,59.375,63.881Z",
    transform: "translate(-21.848 -51.824)",
    fill: "#dbd9f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16603",
    "data-name": "Group 16603",
    transform: "translate(1300.05 4003.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60-2",
    "data-name": "Path 60",
    d: "M117.59,75.937a12.692,12.692,0,0,0-6.04-10.067c-6.04-3.775-9.312,2.013-12.584,3.9S94.184,59.83,87.641,54.293s-12-1.007-14.052,6.04-6.837,9.061-12.625,5.537S51.4,74.427,51.652,75.937Z",
    transform: "translate(-51.64 -51.821)",
    fill: "#eeedfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61-2",
    "data-name": "Path 61",
    d: "M59.375,63.881c-1.581-4.762-5.279-9.35-7.735-12.036,1.883-.15,3.982.566,6.209,2.45,6.544,5.537,8.054,17.365,11.325,15.478s6.543-7.676,12.584-3.9A12.692,12.692,0,0,1,87.8,75.939H59.946A23.516,23.516,0,0,0,59.375,63.881Z",
    transform: "translate(-21.848 -51.824)",
    fill: "#dbd9f8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16604",
    "data-name": "Group 16604",
    transform: "translate(1185.05 4042.413)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60-3",
    "data-name": "Path 60",
    d: "M117.59,75.937a12.692,12.692,0,0,0-6.04-10.067c-6.04-3.775-9.312,2.013-12.584,3.9S94.184,59.83,87.641,54.293s-12-1.007-14.052,6.04-6.837,9.061-12.625,5.537S51.4,74.427,51.652,75.937Z",
    transform: "translate(-51.64 -51.821)",
    fill: "#eeedfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61-3",
    "data-name": "Path 61",
    d: "M59.375,63.881c-1.581-4.762-5.279-9.35-7.735-12.036,1.883-.15,3.982.566,6.209,2.45,6.544,5.537,8.054,17.365,11.325,15.478s6.543-7.676,12.584-3.9A12.692,12.692,0,0,1,87.8,75.939H59.946A23.516,23.516,0,0,0,59.375,63.881Z",
    transform: "translate(-21.848 -51.824)",
    fill: "#dbd9f8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35404-2",
    "data-name": "Group 35404"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35331",
    "data-name": "Group 35331",
    transform: "translate(819.196 3710.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35342",
    "data-name": "Group 35342",
    transform: "translate(467.047 247.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35341",
    "data-name": "Group 35341"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18286",
    "data-name": "Rectangle 18286",
    width: 4.211,
    height: 24.563,
    rx: 2.105,
    transform: "translate(0 40.166)",
    fill: "#cecefd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18287",
    "data-name": "Rectangle 18287",
    width: 4.211,
    height: 41.182,
    rx: 2.105,
    transform: "translate(115.093 40.478)",
    fill: "#cecefd"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18288",
    "data-name": "Rectangle 18288",
    width: 6.551,
    height: 12.281,
    rx: 3.275,
    transform: "translate(0 71.731)",
    fill: "#cecefd"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18289",
    "data-name": "Rectangle 18289",
    width: 112.813,
    height: 211.238,
    rx: 17,
    transform: "translate(3.27 0)",
    fill: "#cecefd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_35066",
    "data-name": "Path 35066",
    d: "M0,0H106.22V178.653H0Z",
    transform: "translate(6.824 16.293)",
    fill: "#eeedfc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35340",
    "data-name": "Group 35340",
    transform: "translate(6.551 16.292)",
    opacity: 0.1,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34934",
    "data-name": "Path 34934",
    d: "M659.522,557.146l81.1-130.111H698.013l-38.475,61.729-.016.5Z",
    transform: "translate(-659.522 -427.035)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34935",
    "data-name": "Path 34935",
    d: "M763.807,427.035H752.263L659.627,575.657v18.521Z",
    transform: "translate(-659.611 -427.035)",
    fill: "#a49edd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34936",
    "data-name": "Path 34936",
    d: "M930.795,987.771,976.212,914.9V879.719L908.864,987.771Z",
    transform: "translate(-869.976 -809.118)",
    fill: "#fff"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34937",
    "data-name": "Path 34937",
    d: "M751.405,341.412v-2.154a16.737,16.737,0,0,0-16.688-16.688H655.28a16.737,16.737,0,0,0-16.688,16.688v2.154Z",
    transform: "translate(-635.305 -322.57)",
    fill: "#cecefd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34938",
    "data-name": "Path 34938",
    d: "M751.3,1556.618v2.154a16.737,16.737,0,0,1-16.688,16.688H655.177a16.737,16.737,0,0,1-16.688-16.688v-2.154Z",
    transform: "translate(-635.219 -1364.156)",
    fill: "#cecefd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_932",
    "data-name": "Ellipse 932",
    cx: 3.22,
    cy: 3.22,
    r: 3.22,
    transform: "translate(31.877 9.627) rotate(-45)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_933",
    "data-name": "Ellipse 933",
    cx: 5.992,
    cy: 5.992,
    r: 5.992,
    transform: "translate(53.942 195.882)",
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_934",
    "data-name": "Ellipse 934",
    cx: 1.849,
    cy: 1.849,
    r: 1.849,
    transform: "translate(43.734 7.778)",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18291",
    "data-name": "Rectangle 18291",
    width: 32.282,
    height: 1.792,
    rx: 0.896,
    transform: "translate(51.617 8.731)",
    fill: "#fff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34939",
    "data-name": "Path 34939",
    d: "M1265.012,331.656c-.541-.09,10.62,2.052,13.63,15.917C1278.642,347.572,1277.969,333.831,1265.012,331.656Z",
    transform: "translate(-1164.013 -330.236)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35361",
    "data-name": "Group 35361",
    transform: "translate(374.058 296.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35360",
    "data-name": "Group 35360",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35359",
    "data-name": "Group 35359"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35345",
    "data-name": "Group 35345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34941",
    "data-name": "Path 34941",
    d: "M724.011,936.571c.042-.819.282-1.622.27-2.442a4.467,4.467,0,0,0-1.471-3.165c-.712-.654-.2-.787-1.159-.944-1.453-.237-2.586.855-3.51,1.695-3.941,3.578,2.079,6.747,2.3,6.838.455.189.345,1.251.345,1.251l3.621-.668A12.8,12.8,0,0,1,724.011,936.571Z",
    transform: "translate(-697.834 -901.066)",
    fill: "#f4c9c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34942",
    "data-name": "Path 34942",
    d: "M719.871,924.149c-2.431,3.8-5.764,6.694-7.591,5.032-.884-.8,2.012-3.5,4.443-7.3s3.493-7.2,5.726-5.773C725.276,917.918,722.3,920.353,719.871,924.149Z",
    transform: "translate(-696.184 -889.407)",
    fill: "#424880"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34943",
    "data-name": "Path 34943",
    d: "M730.73,929.675a1.241,1.241,0,0,0,.818-1.425,2.086,2.086,0,0,0-.85-1.011,1.665,1.665,0,0,0-1.114-.36,1.229,1.229,0,0,0-.558.3,8.019,8.019,0,0,0-.957.862,4.918,4.918,0,0,0-1.184,3.583l.973,1.036a3.271,3.271,0,0,0,.8.444.621.621,0,0,0,.233.053.367.367,0,0,0,.239-.122,1.307,1.307,0,0,0,.375-1,.314.314,0,0,1,.018-.159c.073-.134.312-.041.493.005a.714.714,0,0,0,.891-.55,2.114,2.114,0,0,0-.252-1.247c-.046-.1-.1-.214-.06-.3A.265.265,0,0,1,730.73,929.675Z",
    transform: "translate(-706.831 -898.507)",
    fill: "#f4c9c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34944",
    "data-name": "Path 34944",
    d: "M719,937.443a4.363,4.363,0,0,0-.7-4.079.516.516,0,0,0-.281-.206.371.371,0,0,0-.368.207.993.993,0,0,0-.091.438c-.021.476.289,1.5-.059,1.867a5.309,5.309,0,0,0-1.246,1.91c-.213.644-.3,1.787.419,2.169l1.933-.407A18.915,18.915,0,0,1,719,937.443Z",
    transform: "translate(-692.519 -903.663)",
    fill: "#f4c9c6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35343",
    "data-name": "Group 35343",
    transform: "translate(8.88 6.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34945",
    "data-name": "Path 34945",
    d: "M685.979,832.6c.893-1.992,1.085-4.327-2.349-6.5-6.235-3.944-8.989-11.866-8.989-11.866l-5.447,7.619-.319-.2-6.046,10.6s9.307-.615,14.379,3.363C680.676,838.335,684.8,835.229,685.979,832.6Z",
    transform: "translate(-659.144 -812.112)",
    fill: "#857eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34946",
    "data-name": "Path 34946",
    d: "M685.263,892.558a4.586,4.586,0,0,0,.534-2.679c-1.6,1.669-4.291,2.54-7.5.757-4.5-2.5-10.962-3.151-13.4-3.312l-2.192,5.143a19.884,19.884,0,0,1,13.785,3.106C680.685,898.489,684.085,895.186,685.263,892.558Z",
    transform: "translate(-658.428 -872.068)",
    fill: "#6f6ae3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34947",
    "data-name": "Path 34947",
    d: "M725.062,827.728c-2.5-1.6-1.861-6.758,1.491-11.993s7.766-7.976,10.268-6.374,1.861,6.758-1.491,11.994S727.564,829.33,725.062,827.728Z",
    transform: "translate(-721.861 -807.738)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_935",
    "data-name": "Ellipse 935",
    cx: 4.351,
    cy: 10.045,
    rx: 4.351,
    ry: 10.045,
    transform: "matrix(-0.842, -0.539, 0.539, -0.842, 7.329, 21.612)",
    fill: "#6f6ae3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34948",
    "data-name": "Path 34948",
    d: "M740.48,849.259c.118-.334-3.175.042-4.594-.694-1.182-.613-3.8,3.532-2.872,4.487,1.241,1.275,2.105,4.3,2.345,4.1A24.117,24.117,0,0,0,740.48,849.259Z",
    transform: "translate(-725.668 -840.222)",
    fill: "#857eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34949",
    "data-name": "Path 34949",
    d: "M758.509,851.168c-.793,1.239-2.089,1.825-2.9,1.309s-.816-1.939-.023-3.177,2.09-1.825,2.9-1.309S759.3,849.929,758.509,851.168Z",
    transform: "translate(-748.267 -839.648)",
    fill: "#f3eae2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34950",
    "data-name": "Path 34950",
    d: "M683.652,879.669l-2.056-1.131c4.156-4.366,4.334-4.422,6.869-9.9l2.1,1.71C689.372,874.118,686.668,878.091,683.652,879.669Z",
    transform: "translate(-666.545 -856.741)",
    fill: "#424880"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35344",
    "data-name": "Group 35344",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34951",
    "data-name": "Path 34951",
    d: "M788.449,777.256a.471.471,0,0,0,.42-.682l-3.683-7.3a.47.47,0,1,0-.84.424l3.683,7.3A.471.471,0,0,0,788.449,777.256Z",
    transform: "translate(-774.472 -769.012)",
    fill: "#bebeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34952",
    "data-name": "Path 34952",
    d: "M808.548,814.052a.471.471,0,0,0,.257-.865l-6.854-4.463a.471.471,0,0,0-.513.789l6.854,4.463A.468.468,0,0,0,808.548,814.052Z",
    transform: "translate(-797.613 -801.527)",
    fill: "#bebeef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34953",
    "data-name": "Path 34953",
    d: "M822.614,862.055a.471.471,0,0,0,.015-.941l-8.174-.261a.471.471,0,1,0-.03.941l8.174.261Z",
    transform: "translate(-813.969 -844.352)",
    fill: "#bebeef"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34954",
    "data-name": "Path 34954",
    d: "M466.475,850.983s-14.953,1.85-15.447,15.287,3.651,12.642-6.015,17.623c-9.487,4.888-9.487,37.359,13.513,28.32,24.2-9.513,28.344-16.654,26.74-20.305s-17.138-30.405-17.119-30.654S466.475,850.983,466.475,850.983Z",
    transform: "translate(-409.092 -836.255)",
    fill: "#2a2a76"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34955",
    "data-name": "Path 34955",
    d: "M540.717,976.13c.964-.151,5.26-1.16,5.26-1.16l4.079,21.44s7.775-9.589,16.987-14.144c7.059-3.491,9.768,5.961,9.768,5.961s-24.788,21.165-29.555,20.523C540.935,1007.9,540.717,976.13,540.717,976.13Z",
    transform: "translate(-518.6 -937.966)",
    fill: "#857eee"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34956",
    "data-name": "Path 34956",
    d: "M593.5,1059.333c-.485,7.092,2.841,11.727.024,24.836-2.881,13.407,2.4,24.76-.594,33.673-.993,2.954-20.562,1.533-21.175-2.826-.372-2.644,4.269-22.772,7.29-31.3s1.675-15.444,2.2-21.766C581.692,1056.617,593.97,1052.379,593.5,1059.333Z",
    transform: "translate(-542.027 -1004.191)",
    fill: "#857eee"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34957",
    "data-name": "Path 34957",
    d: "M483.008,1025.679l-22.731-10.285a2.212,2.212,0,0,1-1.1-2.918s3.014-7.18,12.343-5.7c4.651.736,12.09,3.906,15.677,7.138,2.108,1.9-1.27,10.668-1.27,10.668A2.212,2.212,0,0,1,483.008,1025.679Z",
    transform: "translate(-414.994 -963.891)",
    fill: "#857eee"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34958",
    "data-name": "Path 34958",
    d: "M255.8,832.512s1.582-8.4,9.864-9.2,12.368,3.685,17.889,10.4c5.788,7.043,5.817,11.911,7.687,24.2s10.092,6.74,19.109,19.965,2,33.464-20.706,27.586-21.053-27.919-21.053-27.919-2.191-11.087-2.458-13.759S263.283,852.3,263.1,851.36,259.022,838,259.022,838Z",
    transform: "translate(-204.759 -813.476)",
    fill: "#2a2a76"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34959",
    "data-name": "Path 34959",
    d: "M272.682,870.222c3.054,12.051,8.328,7.279,17.345,20.5,5.852,8.583,4.949,20.118-2.611,25.553,3.055-4.448,3.149-9.93-.833-15.381-7.087-9.7-14.722-3.052-18.882-37.16-.552-4.522-9.558-23.363-11.9-24.859C262.612,843.3,267.322,849.075,272.682,870.222Z",
    transform: "translate(-184.438 -826.325)",
    fill: "#22226b"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34960",
    "data-name": "Path 34960",
    d: "M480.059,1380.26q-5.39-.116-10.78-.259c2.083,8.413,3.168,23.376,4.168,26.553,1.491,4.734,12.182,38.553,11.883,45.128h2.73s.04-32.887-4.66-41.961C481.8,1406.631,480.385,1392.643,480.059,1380.26Z",
    transform: "translate(-417.015 -1270.227)",
    fill: "#f4c9c6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34961",
    "data-name": "Path 34961",
    d: "M596.048,1377.874c-3.523-.1-10.833-.391-14.355-.466-1.857,24.355-.4,43.3-7.878,72.147,0,0,3.852.989,4.209,0,13.74-38.1,9.61-31.433,10.816-45.3C589.465,1397.054,593.524,1384.866,596.048,1377.874Z",
    transform: "translate(-543.784 -1268.099)",
    fill: "#f4c9c6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34962",
    "data-name": "Path 34962",
    d: "M496.71,1506.55a37.892,37.892,0,0,0,1.34,5.447,9.639,9.639,0,0,1,9.172.911s-.827-4.126-1.139-6.265Z",
    transform: "translate(-441.105 -1374.039)",
    fill: "#f4b8b4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34963",
    "data-name": "Path 34963",
    d: "M609.31,1499.646c-.053,1.058-.141,4.1-.141,4.1,3.156-.566,4.971-.505,8.367,2.221a47.136,47.136,0,0,1,.968-6.325Z",
    transform: "translate(-572.593 -1368.375)",
    fill: "#f4b8b4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34964",
    "data-name": "Path 34964",
    d: "M515.557,1306.857l-34.732-3.28,2.961-44.9,29.185.062Z",
    transform: "translate(-446.587 -1170.698)",
    fill: "#3d3d60"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34965",
    "data-name": "Path 34965",
    d: "M521.06,1321.863l-31.293-2.934s-.9-32.8,4.27-39.431c2.94-3.767,9.122-2.363,11.912-.215C510.763,1282.99,521.06,1321.863,521.06,1321.863Z",
    transform: "translate(-453.685 -1185.854)",
    fill: "#4b4a80"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35347",
    "data-name": "Group 35347",
    transform: "translate(36.678 13.601)"
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34966",
    "data-name": "Path 34966",
    d: "M511.1,1011.815c-5.478,1.3-9.873,8.914-11.85,11.9s-.6,7.448-.6,7.448a27.819,27.819,0,0,1-.381,8.515c-.745,3.8-3.49,17.208-3.49,17.208s20.311,3.537,23.637,1.923c4.079-1.98,2.46-22.353,2.46-22.353l3.688-20.574S513.185,1011.319,511.1,1011.815Z",
    transform: "translate(-494.78 -981.762)",
    fill: "#f3eae2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34967",
    "data-name": "Path 34967",
    d: "M493.444,1056.3c-1.349-.686-7.627-2.445-10.079.591a50.355,50.355,0,0,0-.255-6.844c3.886,1.909,10.71,3.717,14.744,3.22,5.973-.735,8.591-10.429,12.083-17.229a2.849,2.849,0,0,0,1.424.092l-9.571,43.143-4.557-.22C498.536,1070.956,500.65,1059.963,493.444,1056.3Z",
    transform: "translate(-479.479 -1001.662)",
    fill: "#ddd9e4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34968",
    "data-name": "Path 34968",
    d: "M516.9,1019.23a26.938,26.938,0,0,0-2.3,3.239c-1.682,3.125-.988,4.663.246,5.289a5.847,5.847,0,0,0,7.5-1.8,16.9,16.9,0,0,0,1.8-3.43Z",
    transform: "translate(-497.74 -987.876)",
    fill: "#c36d67"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34969",
    "data-name": "Path 34969",
    d: "M513.931,1019.23a26.941,26.941,0,0,0-2.3,3.239c-1.682,3.125-.988,4.663.246,5.289a5.847,5.847,0,0,0,7.5-1.8,14.2,14.2,0,0,0,1.7-3.91Z",
    transform: "translate(-494.142 -987.876)",
    fill: "#f4c9c6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34970",
    "data-name": "Path 34970",
    d: "M551.964,1024.2c-1.234-.626-1.928-2.164-.246-5.289a45.657,45.657,0,0,1,2.69-3.69l-.452-.19a41.948,41.948,0,0,0-2.866,3.88c-1.682,3.125-.988,4.663.246,5.289a4.937,4.937,0,0,0,2.7.781A4.791,4.791,0,0,1,551.964,1024.2Z",
    transform: "translate(-534.56 -984.428)",
    fill: "#ddd9e4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35346",
    "data-name": "Group 35346",
    transform: "translate(13.63)"
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34971",
    "data-name": "Path 34971",
    d: "M484.077,848.138a50.087,50.087,0,0,0-2.806,11.7c-.436,5.267,1.6,7.83,3.806,8.492a6.074,6.074,0,0,0,3.177.3s-2.206,9.406-2.452,10.073,6.98,2.043,8.716.179l.962-13.5a20.392,20.392,0,0,0,2.973-4.223c.57-1.531,1.143-6.848,1.324-8.25a6.7,6.7,0,0,0-2.045-5.312C496.064,846.131,488.96,841.632,484.077,848.138Z",
    transform: "translate(-481.211 -844.715)",
    fill: "#f4c9c6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_34972",
    "data-name": "Path 34972",
    d: "M525.22,972.723a27.457,27.457,0,0,0,3.737-1.127s-2.623,3.4-4.256,3.33Z",
    transform: "translate(-518.178 -948.8)",
    opacity: 0.2,
    fill: "url(#linear-gradient)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34973",
    "data-name": "Path 34973",
    d: "M471.858,911.411c-.321,1.344-.694,3.04.486,3.322s2.95-1.883,3.27-3.228-.358-1.856-1.539-2.138S472.178,910.067,471.858,911.411Z",
    transform: "translate(-405.054 -884.111)",
    fill: "#f4c9c6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34974",
    "data-name": "Path 34974",
    d: "M431.193,1042.988c-4.8,5.241-7.036,11.664-4.219,24.773,2.881,13.407-1.238,22.563.818,31.2.923,3.877,15.928,5.2,20.773,2.728,1.351-.689-4.091-25.854-7.112-34.384s3.157-26.416,3.157-26.416-.066-5.222-6.369-6.994C434.425,1032.823,438.149,1035.4,431.193,1042.988Z",
    transform: "translate(-369.908 -986.114)",
    fill: "#857eee"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18292",
    "data-name": "Rectangle 18292",
    d: "M1.468,0H9.856a1.468,1.468,0,0,1,1.468,1.468v.244A1.467,1.467,0,0,1,9.857,3.179H1.468A1.468,1.468,0,0,1,0,1.711V1.468A1.468,1.468,0,0,1,1.468,0Z",
    transform: "matrix(-0.987, 0.16, -0.16, -0.987, 72.307, 92.148)",
    fill: "#6f6ae3"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34975",
    "data-name": "Path 34975",
    d: "M530.965,1208.835c0,.776-.441,1.4-.984,1.4s-.984-.629-.984-1.4.441-1.4.984-1.4S530.965,1208.06,530.965,1208.835Z",
    transform: "translate(-470.649 -1128.662)",
    fill: "#f3eae2"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34976",
    "data-name": "Path 34976",
    d: "M345.319,1348.551c-1.065-.736-2.558-1.3-2.95-1.631-.105-.09-1.455-1.451-2.4-2.407a5.48,5.48,0,0,1-1.436-2.535,3.529,3.529,0,0,1-.1-1.845s1.38-1.016,2.375-.483l.9,2.115a6.449,6.449,0,0,0,2.608.523c1.832.143,3.231,2.053,4.56,3.131a4.632,4.632,0,0,1,1.61,3.741,5.089,5.089,0,0,1-1.693-1.3,6.384,6.384,0,0,0-3.354-1.582c-.141-.019-.506-.025-.575.135-.2.477.831.987,1.263,1.425.605.614.7,1.245.5,1.528C346.405,1349.667,346.079,1349.077,345.319,1348.551Z",
    transform: "translate(-255.911 -1236.998)",
    fill: "#f4c9c6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34977",
    "data-name": "Path 34977",
    d: "M400.965,1119.08l2.715-1.648s-10.569-32.558-11.8-50.945l-3.579-.851-4.935-.312S383.462,1098.895,400.965,1119.08Z",
    transform: "translate(-317.199 -1012.087)",
    fill: "#857eee"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34978",
    "data-name": "Path 34978",
    d: "M407.044,1074.745c.049,1.091.908,24.306,16.111,43.17h0s-19.02-33.444-13.725-51.768C409.43,1066.146,406.891,1071.328,407.044,1074.745Z",
    transform: "translate(-340.927 -1012.761)",
    fill: "#6f6ae3"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_936",
    "data-name": "Ellipse 936",
    cx: 2.327,
    cy: 2.327,
    r: 2.327,
    transform: "translate(61.471 33.175) rotate(-135)",
    opacity: 0.2,
    fill: "url(#linear-gradient-2)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34979",
    "data-name": "Path 34979",
    d: "M569.827,911.756a2.311,2.311,0,0,0-2.662-2.3,32.88,32.88,0,0,0-.478,3.4c-.03.366-.047.718-.055,1.058a2.325,2.325,0,0,0,3.194-2.159Z",
    transform: "translate(-516.273 -884.201)",
    opacity: 0.2,
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35350",
    "data-name": "Group 35350",
    transform: "translate(52.858 19.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35349",
    "data-name": "Group 35349",
    transform: "translate(1.546 3.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35348",
    "data-name": "Group 35348",
    transform: "translate(0.292 4.832)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34986",
    "data-name": "Path 34986",
    d: "M546.263,923.607a1.932,1.932,0,0,1,.854.054,2.761,2.761,0,0,1-1.882.9.315.315,0,0,1-.319-.14,3.246,3.246,0,0,1-.634-1.1.621.621,0,0,1-.044-.254c.025-.285.188-.167.324-.053a2.576,2.576,0,0,0,1.7.591Z",
    transform: "translate(-544.236 -922.892)",
    fill: "#80443d"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_34987",
    "data-name": "Path 34987",
    d: "M550.368,902.333c-.114-.2-.254-.379-.372-.575a4.308,4.308,0,0,1-.37-.758c1.055-.307,1.344-1.206,1.639-2.236a3.108,3.108,0,0,0-.348-2.5,1.112,1.112,0,0,0-.242-.264c.033.078.045.16.073.238a5.987,5.987,0,0,1,.2.61,3.847,3.847,0,0,1-.05,1.932,3.122,3.122,0,0,1-.588,1.125,2.467,2.467,0,0,1-1.228.824s.36.879.4.953a3.249,3.249,0,0,0,.359.545,1.127,1.127,0,0,0,.5.421.357.357,0,0,0,.205.006.686.686,0,0,1-.074-.115q-.014-.026-.026-.053C550.424,902.435,550.4,902.383,550.368,902.333Z",
    transform: "translate(-549.082 -896)",
    opacity: 0.2,
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34991",
    "data-name": "Path 34991",
    d: "M520.707,829.125s-5.563,6.574-13.869,4.613c0,0,4.653-8.287,9.862-7.686S520.707,829.125,520.707,829.125Z",
    transform: "translate(-456.53 -815.779)",
    fill: "#2a2a76"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34992",
    "data-name": "Path 34992",
    d: "M475.42,830.494c-5.608-3.9-5.89-2.09-6.048.1-.292,2.12-.684,9.008,6,11.436l1.288-5.4A4.225,4.225,0,0,0,475.42,830.494Z",
    transform: "translate(-406.449 -817.571)",
    fill: "#2a2a76"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34993",
    "data-name": "Path 34993",
    d: "M679.575,1773.276s.664-1.811-2.967.062-7.518,3.468-4.9,3.656,11.579.064,12.118-.254c1.16-.683.251-3.609.251-3.609S680.306,1774.051,679.575,1773.276Z",
    transform: "translate(-649.592 -1592.198)",
    fill: "#253141"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34994",
    "data-name": "Path 34994",
    d: "M532.5,1319.569c-1.326,3.982-.959,9.677-.2,14.1A104.819,104.819,0,0,1,532.5,1319.569Z",
    transform: "translate(-472.65 -1220.652)",
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35351",
    "data-name": "Group 35351",
    transform: "translate(71.912 115.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34995",
    "data-name": "Path 34995",
    d: "M442.136,1409.3s-3.592-.029-2.648.521S443.674,1409.259,442.136,1409.3Z",
    transform: "translate(-438.03 -1409.301)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34996",
    "data-name": "Path 34996",
    d: "M461.465,1411.125s.526.742-.077.649S461.169,1410.378,461.465,1411.125Z",
    transform: "translate(-461.069 -1410.609)",
    fill: "#fff"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34997",
    "data-name": "Path 34997",
    d: "M465.572,1775.95c0-1.068-1.891-3.462-4.224-3.462s-4.326,2.8-4.326,3.869,1.908.639,4.241.639S465.572,1777.018,465.572,1775.95Z",
    transform: "translate(-392.325 -1592.197)",
    fill: "#253141"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35358",
    "data-name": "Group 35358",
    transform: "translate(47.891 19.976)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35355",
    "data-name": "Group 35355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35352",
    "data-name": "Group 35352",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34998",
    "data-name": "Path 34998",
    d: "M558.444,885.947l.62-2.813a1.554,1.554,0,0,0-1.164-1.873l-4.839-1.031a1.579,1.579,0,0,0-1.851,1.23l-.62,2.813a1.557,1.557,0,0,0,1.167,1.875l4.84,1.032A1.577,1.577,0,0,0,558.444,885.947Zm-.62-4.34a1.209,1.209,0,0,1,.906,1.457l-.619,2.811a1.231,1.231,0,0,1-1.439.959l-4.84-1.032a1.214,1.214,0,0,1-.908-1.459l.621-2.812a1.231,1.231,0,0,1,1.438-.958Z",
    transform: "translate(-550.551 -880.196)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35353",
    "data-name": "Group 35353",
    transform: "translate(10.271 2.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34999",
    "data-name": "Path 34999",
    d: "M501.281,898.141l.618-2.813a1.552,1.552,0,0,0-1.167-1.875l-4.835-1.032a1.584,1.584,0,0,0-1.852,1.23l-.621,2.813a1.559,1.559,0,0,0,1.167,1.874l4.84,1.033A1.582,1.582,0,0,0,501.281,898.141Zm-.623-4.343a1.213,1.213,0,0,1,.907,1.459l-.62,2.811a1.229,1.229,0,0,1-1.439.957l-4.838-1.031a1.212,1.212,0,0,1-.908-1.458l.619-2.812a1.233,1.233,0,0,1,1.442-.958Z",
    transform: "translate(-493.385 -892.388)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35354",
    "data-name": "Group 35354",
    transform: "translate(8.02 4.033)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35000",
    "data-name": "Path 35000",
    d: "M540.529,903.573l-2.752-.588.078-.344,2.75.588Z",
    transform: "translate(-537.778 -902.642)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35356",
    "data-name": "Group 35356",
    transform: "translate(2.298 0.374)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35001",
    "data-name": "Path 35001",
    d: "M564.483,890.337l.608.13-1.142-5.717-.608-.13Z",
    transform: "translate(-561.135 -884.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35002",
    "data-name": "Path 35002",
    d: "M572.2,887.942l1.437.307-1.142-5.718-1.072-.229a1.162,1.162,0,0,0-.354-.02Z",
    transform: "translate(-571.066 -882.276)",
    fill: "#fff"
  })))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35005",
    "data-name": "Path 35005",
    d: "M484.627,906.091l-1.906-.39.056-.466,2.091.724Z",
    transform: "translate(-416.239 -880.76)",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35006",
    "data-name": "Path 35006",
    d: "M506.367,833.07c-.146.238,2.991-4.612,10.1-3.388C516.464,829.682,509.861,827.38,506.367,833.07Z",
    transform: "translate(-452.081 -818.404)",
    fill: "#fff"
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35381",
    "data-name": "Group 35381",
    transform: "translate(185.131 191.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35061",
    "data-name": "Path 35061",
    d: "M1447.559,317.163l.974,1.778,1.778.973-1.778.973-.974,1.778-.972-1.778-1.778-.973,1.778-.973Z",
    transform: "translate(-1271.256 -294.529)",
    fill: "#a7a6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35062",
    "data-name": "Path 35062",
    d: "M983.747,251.064l.973,1.779,1.778.973-1.778.973-.973,1.779-.974-1.779-1.778-.973,1.778-.973Z",
    transform: "translate(-890.774 -240.306)",
    fill: "#a7a6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35063",
    "data-name": "Path 35063",
    d: "M482.907,355.922l1.436,2.628,2.628,1.437-2.628,1.438-1.436,2.628-1.439-2.628-2.628-1.438,2.628-1.437Z",
    transform: "translate(-478.84 -326.325)",
    fill: "#a7a6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35064",
    "data-name": "Path 35064",
    d: "M1670.01,528.614l1.437,2.628,2.629,1.438-2.629,1.437-1.437,2.628-1.437-2.628-2.629-1.437,2.629-1.438Z",
    transform: "translate(-1229.661 -517.989)",
    fill: "#a7a6f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35065",
    "data-name": "Path 35065",
    d: "M1311.748,191.185l2.242,4.1,4.1,2.241-4.1,2.242-2.242,4.1-2.241-4.1-4.1-2.242,4.1-2.241Z",
    transform: "translate(-721.9 -183.185)",
    fill: "#a7a6f1"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35397",
    "data-name": "Group 35397",
    transform: "translate(493.638 3404.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35395",
    "data-name": "Group 35395",
    transform: "translate(1115.198 550.248)"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35384",
    "data-name": "Group 35384",
    transform: "translate(23.227 119.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35383",
    "data-name": "Group 35383"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35067",
    "data-name": "Path 35067",
    d: "M1277.035,1300.263s14.366-34.954,14.031-47.029c-.26-9.359,8.833-33.38,9.258-35.412,1.036-4.951,2.13-2.225,2.827,0,.283.9,5.674,30.775,6.262,35.492,1.007,8.05,8.913,46.659,8.913,46.659l5.972,1.126s-2.868-46.076-2.868-48.75-.056-44.514-1.319-57.991c-1.284-13.7-32.377,1.3-32.377,1.3s-9.12,51.784-9.615,57.411c-.724,8.245-8,47.2-8,47.2Z",
    transform: "translate(-1270.115 -1188.589)",
    fill: "#2a2a76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35068",
    "data-name": "Path 35068",
    d: "M1398.922,1309.479c3.271,2.264,7.344,7.453,15.439-2C1408.776,1309.474,1404.082,1309.35,1398.922,1309.479Z",
    transform: "translate(-1374.096 -1284.565)",
    fill: "#22226b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35069",
    "data-name": "Path 35069",
    d: "M1503.8,1218.525l7.4,106,1.745.732-4.187-106.741Z",
    transform: "translate(-1458.76 -1212.749)",
    fill: "#22226b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35070",
    "data-name": "Path 35070",
    d: "M1316.219,1327.364s-9.954,24.81-9.526,37.513c.468,13.906-13.021,47.269-13.027,47.285.385-.213,2.188.7,2.38.128,3.935-11.729,14.268-37.8,14.033-46.254-.26-9.359,9.508-35.262,9.933-37.294C1320.1,1328.323,1316.219,1327.364,1316.219,1327.364Z",
    transform: "translate(-1289.128 -1300.617)",
    fill: "#22226b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35394",
    "data-name": "Group 35394",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35393",
    "data-name": "Group 35393"
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35071",
    "data-name": "Path 35071",
    d: "M1472.341,766.823a6.543,6.543,0,0,0-1.023-3.107c1.077-2.077-.9-3.778-2.385-4.876a23.274,23.274,0,0,0-5.929-2.793,9.173,9.173,0,0,0-5.821-.468,3.056,3.056,0,0,0-2.007,1.562,2.854,2.854,0,0,0,.34,2.523,4.15,4.15,0,0,0-2.738.368,2.793,2.793,0,0,0-1.471,2.279,2.079,2.079,0,0,0,1.562,2.085,2.254,2.254,0,0,0-.694,2.767,3.45,3.45,0,0,0,1.576,1.864,2.643,2.643,0,0,0,2.389.058l15.356,3.6A13.659,13.659,0,0,0,1472.341,766.823Z",
    transform: "translate(-1393.156 -719.643)",
    fill: "#253141"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35392",
    "data-name": "Group 35392"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35388",
    "data-name": "Group 35388",
    transform: "translate(54.057 41.192)"
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35072",
    "data-name": "Path 35072",
    d: "M1453.176,861.052c-.883.024-7.41.859-7.41.859l-5.933-1.045-9.758,27.147,12.716,6.219S1454.062,861.027,1453.176,861.052Z",
    transform: "translate(-1430.076 -846.065)",
    fill: "#edcecc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35073",
    "data-name": "Path 35073",
    d: "M1466.094,895.745c2.3-3.551-.282-4.267-3.517-4.072l-1.278,1.161-7.27.354-2.737,8.9S1461.394,903,1466.094,895.745Z",
    transform: "translate(-1447.202 -870.911)",
    opacity: 0.2,
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35074",
    "data-name": "Path 35074",
    d: "M1453.591,787.59c-1.457,3.286-4.625,13.613-4.625,13.613s-2.622,6.319,2.143,8.227,7.772,2.661,9.932,1.474,4.686-3.759,6.349-12.3,2.508-8.242.97-10.331c-.991-1.345-3.794-3.569-5.433-3.892C1456.244,783.064,1454.127,786.382,1453.591,787.59Z",
    transform: "translate(-1444.744 -784.076)",
    fill: "#edcecc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35075",
    "data-name": "Path 35075",
    d: "M1457.516,846.777a2.619,2.619,0,0,0-2.512-3.1,25.86,25.86,0,0,0-1.148,3.028c-.107.4-.575,1.539-.651,1.917a4.441,4.441,0,0,0,1.25.286A2.638,2.638,0,0,0,1457.516,846.777Z",
    transform: "translate(-1448.747 -832.191)",
    opacity: 0.2,
    fill: "url(#linear-gradient-6)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35076",
    "data-name": "Path 35076",
    d: "M1467.053,849.646c-.054,0-.107,0-.16-.005a9.776,9.776,0,0,1-.436,2.166c-.787,2.77-2.179,4.451-3.894,4.891s-3.335.609-4.858-1.659a4.227,4.227,0,0,0-4.969-1.583c-1.245.309-3.073-1.138-3.133-1.21l-.638,1.877s-2.621,6.319,2.143,8.227,7.772,2.661,9.932,1.474,4.686-3.759,6.349-12.3c.13-.664.253-1.292.371-1.89C1467.524,849.642,1467.288,849.648,1467.053,849.646Z",
    transform: "translate(-1444.744 -836.995)",
    fill: "#253141"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_35077",
    "data-name": "Path 35077",
    d: "M1513.985,862.122a2.539,2.539,0,1,1-2.52-2.559A2.539,2.539,0,0,1,1513.985,862.122Z",
    transform: "translate(-1493.713 -845.013)",
    opacity: 0.2,
    fill: "url(#linear-gradient-7)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35086",
    "data-name": "Path 35086",
    d: "M1378.665,931.6a13.166,13.166,0,0,1-5.78,1.353,13.419,13.419,0,0,1-9.1-3.854,10.225,10.225,0,0,1-1.558-1.856l-7.477-2.776-.785,17.441-4.908,16.6-4.528,14.944-1.24,11.142,34.871,3.837-1.572-41.654s2.713-5.676,2.5-6.046,3.937-7,3.937-7Z",
    transform: "translate(-1305.957 -856.219)",
    fill: "#f3eae2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35389",
    "data-name": "Group 35389",
    transform: "translate(128.991 46.153)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35088",
    "data-name": "Path 35088",
    d: "M1819.685,813.1c-.589-.513-1.11-.915-.646-1.691a3.615,3.615,0,0,1,1.452-1.393,2.18,2.18,0,0,1,1.529-.106,1.606,1.606,0,0,1,.614.556,10.5,10.5,0,0,1,.944,1.4c.768,1.432,1.931,3.578,1.406,5.315l-2.59.619a4.281,4.281,0,0,1-1.154.314.809.809,0,0,1-.313-.006.479.479,0,0,1-.265-.229,1.71,1.71,0,0,1-.162-1.389.412.412,0,0,0,.027-.207c-.051-.193-.383-.149-.628-.148a.934.934,0,0,1-.959-.979,2.767,2.767,0,0,1,.711-1.505c.09-.114.19-.241.17-.359A.345.345,0,0,0,1819.685,813.1Z",
    transform: "translate(-1818.861 -809.815)",
    fill: "url(#linear-gradient-8)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35400",
    "data-name": "Group 35400"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35087",
    "data-name": "Path 35087",
    d: "M1795.567,821.4c.2-1.053.152-2.149.424-3.187a5.846,5.846,0,0,1,2.864-3.557c1.11-.607.5-.938,1.768-.835,1.92.155,3.015,1.9,3.926,3.256,3.882,5.784-4.762,7.917-5.069,7.964-.638.1-.831,1.481-.831,1.481l-4.39-1.987A16.754,16.754,0,0,0,1795.567,821.4Z",
    transform: "translate(-1670.009 -766.884)",
    fill: "#edcecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35089",
    "data-name": "Path 35089",
    d: "M1823.871,808.492a1.624,1.624,0,0,1-.592-2.067,2.73,2.73,0,0,1,1.4-1.017,2.179,2.179,0,0,1,1.529-.106,1.61,1.61,0,0,1,.614.556,10.527,10.527,0,0,1,.944,1.4c.768,1.432,1.536,4.522,1.012,6.26l-2.2-.326a4.283,4.283,0,0,1-1.154.314.812.812,0,0,1-.313-.005.48.48,0,0,1-.265-.229,1.711,1.711,0,0,1-.162-1.389.411.411,0,0,0,.028-.207c-.051-.193-.383-.15-.628-.149a.934.934,0,0,1-.959-.979,2.765,2.765,0,0,1,.711-1.505c.09-.114.19-.242.17-.359A.347.347,0,0,0,1823.871,808.492Z",
    transform: "translate(-1693.284 -759.939)",
    fill: "#edcecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35090",
    "data-name": "Path 35090",
    d: "M1801.459,816.331a5.916,5.916,0,0,1,1.9-4.869c.447-.419,1.138-1.117,1.578-1.108.492.01.7.322.608.494-.286.509-1.078,1.118-1.117,1.31-.123.611-.838,1.811-.512,2.391a6.949,6.949,0,0,1,.982,2.818c.068.885-.185,2.364-1.214,2.624l-2.328-1.125A24.78,24.78,0,0,0,1801.459,816.331Z",
    transform: "translate(-1675.738 -764.097)",
    fill: "#edcecc"
  }))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35101",
    "data-name": "Path 35101",
    d: "M1488.3,870.342s-11.163,15.759-2.569,62.507c0,0,9,1.2,11.8,0,0,0-1.108-24.161-1.694-44.016,0,0,40.04-10.27,52.708-35.205l-4.606-4.325S1519.081,874.278,1488.3,870.342Z",
    transform: "translate(-1418.32 -795.539)",
    fill: "#7777d5"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35102",
    "data-name": "Path 35102",
    d: "M1281.648,810.725s-3.326,10.2-9.233,26.553c-5.992,16.581-5.263,38.283-5.263,38.283l-10.075-5s2.078-24.371,12.229-42.318a97.872,97.872,0,0,1-28.518-44.966l4.786-2.708S1255.052,804,1281.648,810.725Z",
    transform: "translate(-1223.212 -740.05)",
    fill: "#7777d5"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35103",
    "data-name": "Path 35103",
    d: "M1556.712,883.548c-6.283,6.835-26.888,25.4-53.423,31.758,0,0,4.375,35.334-3.093,37.221-1.654.418-4.453-.464-6.055-.32.245,1.733.672,6.5,1,8.287,0,0,9,1.2,11.8,0,0,0-.6-22.711-1.186-42.566C1505.758,917.927,1542.893,907.048,1556.712,883.548Z",
    transform: "translate(-1427.736 -823.184)",
    fill: "#5050ad"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35104",
    "data-name": "Path 35104",
    d: "M1266.966,839.772c-7.97,23.917-9.89,42.13-9.89,42.13l10.075,5s-.53-6.74,0-8.352c-4.479-.9-2.089-20.719,1.112-33.1,1.934-7.482,3-8.462,3-8.462-21.141-15.589-30.478-42.374-30.478-42.374C1249.131,823.214,1266.966,839.772,1266.966,839.772Z",
    transform: "translate(-1223.212 -751.394)",
    fill: "#5050ad"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35105",
    "data-name": "Path 35105",
    d: "M1415.878,939.618c-.923,1.79-5.083-1.1-5.2-1.772s4.911-7.166,4.911-7.166l1.753-.031S1417.032,937.38,1415.878,939.618Z",
    transform: "translate(-1360.355 -861.206)",
    fill: "#3d3d60"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35106",
    "data-name": "Path 35106",
    d: "M1418.733,937.2c-.923,1.789-5.37-.916-5.49-1.588s4.4-6.949,4.4-6.949l3.813.4A61.063,61.063,0,0,1,1418.733,937.2Z",
    transform: "translate(-1362.428 -859.606)",
    fill: "#5959a0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35107",
    "data-name": "Path 35107",
    d: "M1503.332,954.306c-.633,1.912,4.345,2.859,4.908,2.474s1.679-8.524,1.679-8.524l-1.2-1.273S1504.122,951.915,1503.332,954.306Z",
    transform: "translate(-1435.11 -874.392)",
    fill: "#3d3d60"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35108",
    "data-name": "Path 35108",
    d: "M1503.511,949.657c-.631,1.912,4.414,3.193,4.978,2.808s1.886-8.534,1.886-8.534l-3.59-1.309A64.871,64.871,0,0,0,1503.511,949.657Z",
    transform: "translate(-1435.255 -870.872)",
    fill: "#5959a0"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35109",
    "data-name": "Path 35109",
    d: "M1514.189,782.854a6.244,6.244,0,0,0-2.242-2.762,23.517,23.517,0,0,0-2.936-1.654,11.342,11.342,0,0,0-3-1.085,3.391,3.391,0,0,0-2.745.439l-.18.162a3.49,3.49,0,0,0,1.75,2.725,8.958,8.958,0,0,0,6.2,1.526,21.27,21.27,0,0,0-.252,3.226c.115,1.436.527,5.268.512,7.115,0,.621-2.691,8.74-2.176,8.393.6-.4,4.31-7.159,5.014-11.348C1514.519,787.313,1514.9,785.057,1514.189,782.854Z",
    transform: "translate(-1434.958 -737.377)",
    fill: "#253141"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35110",
    "data-name": "Path 35110",
    d: "M1535,848.474c-.355,1.439-.77,3.255.494,3.568s3.18-2,3.535-3.435-.369-1.994-1.632-2.306S1535.358,847.035,1535,848.474Z",
    transform: "translate(-1460.431 -793.071)",
    fill: "#edcecc"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35111",
    "data-name": "Path 35111",
    d: "M1472.822,881.024c.628.167,1.187-.108,1.581.259a.826.826,0,0,1,.217.858,1.277,1.277,0,0,1-.634.676,2.353,2.353,0,0,1-1.8.116c-1.534-.523-1.738-1.6-1.558-2.093a.816.816,0,0,1,.882-.507C1471.881,880.39,1472.371,880.9,1472.822,881.024Z",
    transform: "translate(-1408.708 -820.581)",
    fill: "#fff"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35112",
    "data-name": "Path 35112",
    d: "M1220.526,1758.626s.959-2.616-4.286.09-10.86,5.009-7.073,5.282,16.727.092,17.506-.366c1.676-.987.362-5.214.362-5.214S1221.581,1759.745,1220.526,1758.626Z",
    transform: "translate(-1196.687 -1528.683)",
    fill: "#253141"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35113",
    "data-name": "Path 35113",
    d: "M1510.193,1764.274c0-1.476-2.614-4.784-5.838-4.784s-5.978,3.87-5.978,5.346,2.637.884,5.861.884S1510.193,1765.75,1510.193,1764.274Z",
    transform: "translate(-315.957 -980.051)",
    fill: "#253141"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35401",
    "data-name": "Group 35401",
    transform: "matrix(-0.891, 0.454, -0.454, -0.891, 1631.143, 3996.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35087-2",
    "data-name": "Path 35087",
    d: "M1.309,5.121c.2,1.053.152,2.149.424,3.187A5.846,5.846,0,0,0,4.6,11.866c1.11.607.5.938,1.768.835,1.92-.155,3.015-1.9,3.926-3.256,3.882-5.784-4.762-7.918-5.069-7.964C4.583,1.384,4.39,0,4.39,0L0,1.987A16.754,16.754,0,0,1,1.309,5.121Z",
    transform: "translate(0 0)",
    fill: "#edcecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35089-2",
    "data-name": "Path 35089",
    d: "M.781,5.022A1.624,1.624,0,0,0,.189,7.089a2.73,2.73,0,0,0,1.4,1.017,2.179,2.179,0,0,0,1.529.106,1.61,1.61,0,0,0,.614-.556,10.523,10.523,0,0,0,.944-1.4C5.442,4.828,6.21,1.737,5.686,0L3.49.326A4.283,4.283,0,0,0,2.336.012a.812.812,0,0,0-.313.005.48.48,0,0,0-.265.229A1.711,1.711,0,0,0,1.6,1.636a.411.411,0,0,1,.028.207c-.051.193-.383.15-.628.149a.934.934,0,0,0-.959.979A2.765,2.765,0,0,0,.749,4.476c.09.114.19.242.17.359A.347.347,0,0,1,.781,5.022Z",
    transform: "translate(5.557 6.067)",
    fill: "#edcecc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35090-2",
    "data-name": "Path 35090",
    d: "M.1,3.66A5.916,5.916,0,0,0,2,8.529c.447.419,1.138,1.117,1.578,1.108.492-.01.7-.322.608-.494C3.9,8.634,3.111,8.025,3.072,7.833c-.123-.611-.838-1.811-.512-2.391a6.949,6.949,0,0,0,.982-2.818C3.61,1.739,3.357.26,2.328,0L0,1.125A24.781,24.781,0,0,1,.1,3.66Z",
    transform: "translate(1.368 3.748)",
    fill: "#edcecc"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_35402",
    "data-name": "Group 35402",
    transform: "matrix(0.995, 0.105, -0.105, 0.995, 11620.623, 6591.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16498",
    "data-name": "Group 16498",
    transform: "translate(-10281.156 -1626.073)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16493",
    "data-name": "Group 16493",
    transform: "translate(58.79 71.423)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12353",
    "data-name": "Path 12353",
    d: "M6136.755,1262.418s-.939,5.531-7.6,4.985l-5.831-8.323,0,0-26.351-37.609-8.588-12.255,7.6-4.987,2.6,3.714,37.371,53.335Z",
    transform: "translate(-6088.382 -1204.227)",
    fill: "#242452"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16494",
    "data-name": "Group 16494",
    transform: "translate(58.79 71.424)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12354",
    "data-name": "Path 12354",
    d: "M6096.97,1221.472l-8.588-12.255,7.6-4.987,2.6,3.714C6096.122,1211.415,6096.494,1217.8,6096.97,1221.472Z",
    transform: "translate(-6088.382 -1204.23)",
    fill: "#11118e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16495",
    "data-name": "Group 16495",
    transform: "translate(53.097 66.07)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12355",
    "data-name": "Path 12355",
    d: "M6053.958,1161.826l-11.8,8.125a1.687,1.687,0,0,1-2.307-.571l-2.061-3.095,14.562-9.629,1.9,2.811A1.686,1.686,0,0,1,6053.958,1161.826Z",
    transform: "translate(-6037.789 -1156.657)",
    fill: "#8d8de8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M10971.014,1816.3a31.766,31.766,0,1,1,11.989-2.333A31.756,31.756,0,0,1,10971.014,1816.3Zm0-54.964a23.028,23.028,0,1,0,8.693,1.692A23.031,23.031,0,0,0,10971.014,1761.34Z",
    transform: "translate(-10925.951 -1739.381)",
    fill: "#9b9be6",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashDownloadImg);
export default __webpack_public_path__ + "static/media/dash_download_img.db1d2f022ecc262fd7dd74b6abc9f3e2.svg";
export { ForwardRef as ReactComponent };